// extracted by mini-css-extract-plugin
module.exports = {"card":"styles_card__1L-1V","disabled":"styles_disabled__3U0-5"};